import styled from '@emotion/styled'
import { withClass } from 'common/emotion'

import { metrics } from 'component-library/__styling/settings'
import { calcRem } from 'component-library/__styling/style-functions'
import { breakWords } from 'component-library/__styling/style-mixins'

import { TextItem } from 'component-library/typography/TextItem/TextItem'
import { themedValue } from 'component-library/__styling/themed-value'

export const styledListClassName = 'List'

const StyledBaseList = styled('ol')({ ...breakWords, clear: 'both' }, ({ theme }) => ({
    margin: themedValue(theme, {
        fallback: `0 0 ${calcRem(metrics.thewest.textMargin)} 0`,
        perthnow: calcRem(0, 0, metrics.perthnow.textMargin, metrics.perthnow.margins.md),
    }),
    padding: themedValue(theme, {
        fallback: calcRem(0, 32),
        perthnow: calcRem(0, 16),
    }),
}))

export const StyledOrderedList = withClass(styledListClassName)(StyledBaseList)
StyledOrderedList.displayName = 'StyledOrderedList'

export const StyledUnorderedList = withClass(styledListClassName)(
    StyledBaseList.withComponent('ul')
)
StyledUnorderedList.displayName = 'StyledUnorderedList'

export const StyledListItem = styled(TextItem)(({ theme }) => ({
    margin: themedValue(theme, {
        fallback: calcRem(0, 0, 15, 0),
        perthnow: calcRem(0, 0, metrics.perthnow.margins.sm, 0),
        sevennews: 0,
    }),
}))
StyledListItem.displayName = 'StyledListItem'
